import React from 'react';
import ReactDOM from 'react-dom';
import { ContextMenuTrigger } from "react-contextmenu";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import tr from 'date-fns/locale/tr';
import { formatToTimeZone } from 'date-fns-timezone';
import PopupModal from '../../components/popup-modal/popup-modal.component';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator.component';
import ReactTooltip from "react-tooltip";
import JqueryConfirm from '../jquery-confirm/jquery-confirm.component';
import { showWarningLayer, showWarningLayerPopup, hideWarningLayerPopup,generateID } from '../../utils/utils';
import WarningLayerPopup from '../warning-layer-popup/warning-layer-popup.component';
import LoadingLayer from '../loading-layer/loading-layer.component';
import * as actionCreators from '../../redux/login/login.actions';
import { LoginActionTypes } from '../../redux/login/login.types';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tabs/style/react-tabs.css';
import './buses.styles.scss';
import '../../assets/styles/react-bootstrap-table-all.min.css';
import '../../assets/styles/react-contextmenu.css';

//JQUERY CONFIRM DIALOG BOX
const confirmDialog = (open = false, type = 'alert', text = '', action) => () => {
  ReactDOM.render(
      <JqueryConfirm open={open} type={type} action={action}>
        <p className="text-center passwordInfo"><b>{text}</b></p>
      </JqueryConfirm>
   , document.getElementById('jqueryconfirm'));  
}


class Buses extends React.Component {
  constructor(props){
    super(props);
    this.guid = generateID();
    this.excelData = [];
    this.state = {
      loading: false,
      firstLoading:true,
      loadingPopup:false,
      loadingModalNew: false,
      loadingModalEdit:true,
      selectedBusID: null,
      selectedBusData:null,
      modalNewArac:false,
      modalEditArac:false,
      isFilterDisable:true,
      isRowSelected: false,
      baslangicTarihi:null,
      bitisTarihi:null,
      statusOption: {label: 'Aktif', value: 0},
      currentVehicle:{
        BUSPLATE: '',
        BUSCAPACITY: '',
        BUSLIMIT: '',
        ACTIVEFROM: '',
        ACTIVETO: '',
        BUSTAT: '',
        BUDID:''
      },
      columnFilterData:{}      
    }

  }


  componentDidMount(){
    this.getBuses();
  }
  handleNewVehicle = () => {
    this.props.setLoadingPopup(false);
    this.setState({...this.state, baslangicTarihi:null,bitisTarihi:null,statusOption: {label: 'Aktif', value: 0}, modalNewArac:true});    
  }

  handleEditVehicle = () => {
    this.props.setLoadingPopup(false);
    if (this.state.selectedBusData === null){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen araç seçiniz.'});
      showWarningLayer();
      return;      
    }        
    

      this.setState({
        ...this.state,
        modalEditArac: true,
        statusOption: this.state.selectedBusData !== null ? {label: this.state.selectedBusData.BUSSTAT === "0" ? 'Aktif' : 'Pasif', value: this.state.selectedBusData.BUSSTAT === "0" ? 0 : 1} : null,
        baslangicTarihi:this.state.selectedBusData !== null ? this.state.selectedBusData.ACTIVEFROM === "" ? null : new Date(this.state.selectedBusData.ACTIVEFROM) : "",
        bitisTarihi:this.state.selectedBusData !== null ? this.state.selectedBusData.ACTIVETO === "" ? null : new Date(this.state.selectedBusData.ACTIVETO) : "",
      });
    
  }

  insertVehicle = async () => {
    this.props.setLoadingPopup(true);
    let busplate = this.busplate.value.toUpperCase();  
    let buscapacity = this.buscapacity.value;  
    let buslimit = this.buslimit.value;  
    let activefrom = this.state.baslangicTarihi === null ? "" : this.state.baslangicTarihi;  
    let activeto = this.state.bitisTarihi === null ? "" : this.state.bitisTarihi;  
    let busstat = this.state.statusOption.value;  

    if (busplate === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen plaka no giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (buscapacity === "" || buscapacity === 0 ){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen servis kapasitesi giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (buslimit === "" || buslimit === 0 ){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen yolcu limiti giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }    

    let outputfrom = "";
    let outputto = "";

    if (activefrom !== ""){
      const date = new Date(activefrom);
      const format = 'YYYY-MM-DD';
      outputfrom = formatToTimeZone(date, format, { timeZone: 'Europe/Istanbul' });    
    }

    if (activeto !== ""){
      const date = new Date(activeto);
      const format = 'YYYY-MM-DD';
      outputto = formatToTimeZone(date, format, { timeZone: 'Europe/Istanbul' });    
    }

    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/add-bus`,
      {
        "sid": this.props.user.SessionID,
        "busplate": busplate,
        "buscapacity":buscapacity,
        "buslimit":buslimit,
        "activefrom":outputfrom,
        "activeto":outputto,
        "busstat":busstat
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');   
        this.props.setLoadingPopup(false);       
      }else if (res.data.message === "DP_Busplate"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen plaka no giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Buscapacity"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen servis kapasitesi giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Buslimit"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen yolcu limiti giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }
    } else{
      if (res.data.message === "DP_Done"){
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Araç eklendi.'});
        showWarningLayer();
        this.props.setLoading(true);
        this.getBuses();
        this.setState({...this.state,modalNewArac:false});
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();
      }
      
    } 
  }
  updateVehicle = async () => {
    this.props.setLoadingPopup(true);
    let busid = this.state.selectedBusData.BUSID;
    let busplate = this.busplate.value.toUpperCase();  
    let buscapacity = this.buscapacity.value;  
    let buslimit = this.buslimit.value;  
    let activefrom = this.state.baslangicTarihi === null ? "" : this.state.baslangicTarihi;  
    let activeto = this.state.bitisTarihi === null ? "" : this.state.bitisTarihi;  
    let busstat = this.state.statusOption.value;  


    if (busid === "" || busid === null){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen araç seçiniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }


    if (busplate === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen plaka no giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (buscapacity === "" || buscapacity === 0 ){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen servis kapasitesi giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (buslimit === "" || buslimit === 0 ){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen yolcu limiti giriniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }    

    let outputfrom = "";
    let outputto = "";

    if (activefrom !== ""){
      const date = new Date(activefrom);
      const format = 'YYYY-MM-DD';
      outputfrom = formatToTimeZone(date, format, { timeZone: 'Europe/Istanbul' });    
    }

    if (activeto !== ""){
      const date = new Date(activeto);
      const format = 'YYYY-MM-DD';
      outputto = formatToTimeZone(date, format, { timeZone: 'Europe/Istanbul' });    
    }

    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/update-bus`,
      {
        "sid": this.props.user.SessionID,
        "busplate": busplate,
        "buscapacity":buscapacity,
        "buslimit":buslimit,
        "activefrom":outputfrom,
        "activeto":outputto,
        "busstat":busstat,
        "busid":busid,
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');   
        this.props.setLoadingPopup(false);       
      }else if (res.data.message === "DP_Busplate"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen plaka no giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Buscapacity"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen servis kapasitesi giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Buslimit"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen yolcu limiti giriniz.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();        
      }
    } else{
      if (res.data.message === "DP_Done"){
        let selectedBusData = this.state.selectedBusData;
        
        selectedBusData.BUSPLATE = busplate;
        selectedBusData.BUSCAPACITY = buscapacity;
        selectedBusData.BUSLIMIT = buslimit;
        selectedBusData.ACTIVEFROM = outputfrom;
        selectedBusData.ACTIVETO = outputto;
        selectedBusData.BUSSTAT = busstat;
        let statusOption = {label: busstat === 0 ? 'Aktif' : 'Pasif', value: busstat === 0 ? 0 : 1};
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Araç güncellendi.'});
        showWarningLayer();
        this.getBuses();
        this.setState({...this.state,selectedBusData:selectedBusData,statusOption:statusOption,modalEditArac:false});
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();
      }
      
    } 
  }  
  handleVehicleChange = (event) => {
    const { name, value } = event.target;
    this.setState(
      {
        ...this.state,
        currentVehicle: {
          ...this.state.currentVehicle,
          [name.toUpperCase()]:value
        }
      }
    )
  }  

  deleteVehicle = async () => {
    this.props.setLoading(true);
    let busid = this.state.selectedBusData.BUSID;
    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/delete-bus`,
      {
        "sid": this.props.user.SessionID,
        "busid":busid
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');          
      }else if (res.data.message === "DP_Busid"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen araç seçiniz.'});
        showWarningLayer();
        this.props.setLoading(false);
      }
    } else{
      if (res.data.message === "DP_Done"){
        this.props.setLoading(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Araç silindi.'});
        this.getBuses();
        showWarningLayer();
      }else{
        this.props.setLoading(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayer();
      }
      
    } 
  }


  handleFilterSearch = (value) => {
    try{
      this.refs.busplateCol.applyFilter(value);
    }catch(ex){}
    
  }

  getBuses = () => {
    this.setState({
      ...this.state,
      isFilterDisable:true,
      loading:true
    });
    axios.post(`https://azr05.infotraq.com/servisradarsu/get-buses`,{ "sid": this.props.user.SessionID},{crossDomain: true})
    .then(res => {
      if (res.data.type === "error"){
        if (res.data.message === "DP_Session"){
          this.props.logOut();
          this.props.setDefault();
          const bodyElement = document.querySelector('body');
          bodyElement.classList.remove('noBodyImage');          
        }
      } else{
        let buses;
        try{
          buses = res.data.data;
          if (buses === null || buses === undefined){
            buses = [];
          }
        }catch(ex){
          buses = [];
        }
        
        this.props.setExcelData(buses);
        this.setState({...this.state,isFilterDisable:false,firstLoading:false, loading:false});
        this.props.setBuses(buses);
        this.props.setLoading(false);
      }     
    })
  }

  handleBaslangicTarihi = (date) => {
    this.setState({
      ...this.state,
      baslangicTarihi: date
    })
  }

  handleBitisTarihi = (date) => {
    this.setState({
      ...this.state,
      bitisTarihi: date
    })
  }

  handleStatusChange = statusOption => {
    this.setState(
      { statusOption });
  };  

  handleRowSelect = (row, isSelected, e) => {
    this.setState(
      {
      ...this.state,
      selectedBusData: row,
      baslangicTarihi: row.ACTIVEFROM,
      bitisTarihi: row.ACTIVETO,
      isRowSelected: isSelected
      }
      );
  }    

  handleDeleteVehicle = () => {
    if (this.state.isRowSelected === false){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen araç seçiniz.'});
      showWarningLayer();
      return;      
    }    

    confirmDialog(true,'changepassword','Seçilen aracı silmek istediğinize emin misiniz ?',() => this.deleteVehicle())();    

  }  


  //Column Templates
  suColumnType = (cell, row, type) => {
    if (type === "busstat"){
      return cell === "0" ? '<span class="badge badge-success columnInfo">Aktif</span>' : '<span class="badge badge-danger columnInfo">Pasif</span>'
    }
  }    


  afterColumnFilter = (filterConds, result) => {
    //console.log(filterConds);
    const tempData = this.props.excelData;
    if (JSON.stringify(tempData) !== JSON.stringify(result)){
      this.props.setExcelData(result);
    }

    if (JSON.stringify(this.state.columnFilterData) !== JSON.stringify(filterConds)){    
      this.setState({
        ...this.state,
        columnFilterData: filterConds
      });
    }
  }

  render(){
    const durumOptions = [
      { value: 1, label: 'Pasif' },
      { value: 0, label: 'Aktif' }
    ];     
    const editGuid = generateID();
    //let tempDate = formatNow(new Date(),"YYYY-MM-DD");
    //const excelFileName = tempDate;
    const options = {
      sizePerPageList: [],
      hidePageListOnlyOnePage: true,
      sizePerPage: 50,
      noDataText: 'Gösterilecek kayıt yok',
      afterColumnFilter: this.afterColumnFilter,
    };    
    const selectRow = {
      mode: 'radio',  // multi select
      clickToSelect: true,
      className: 'row-select-class',
      bgColor: '#004288',
      Color:'white',
      onSelect: this.handleRowSelect,
      selected: this.state.selectedBusData !== null ? [this.state.selectedBusData.BUSID] : []      
    };   
    const footerData = [
      [
        {
          label: '',
          columnIndex: 1,
          align: 'left',
          formatter: (tableData) => {
            //let total = tableData.length;
            let total = this.props.excelData.length;
            return (
              <strong>Toplam : { total } araç</strong>
            );
          }
          
        }
      ]
    ];    

    const busStatTypes = {
      0: 'Aktif',
      1: 'Pasif'
    };    
    
    //let statusValue = this.state.selectedBusData !== null ? {label: this.state.selectedBusData.BUSSTAT === "0" ? 'Aktif' : 'Pasif', value: this.state.selectedBusData.BUSSTAT === "0" ? 0 : 1} : null;

    return(
      <div className="passengersPageWrapper">
      <div className="card card-body bg-light content-toolbar">
      <div className="d-flex">
          <div className="p-2">
            <button type="button" className="btn btn-sm btn-general btn-light p-2 margin-left-5 userbuttons minibuttons" data-tip="Araç Ekle" onClick={() => this.handleNewVehicle()}><i className="fas fa-plus"></i></button>
            <button type="button" className="btn btn-sm btn-general btn-light margin-left-5 userbuttons minibuttons " data-tip="Araç Düzelt" onClick={() => this.handleEditVehicle()}><i className="fas fa-edit"></i> </button>
            <button type="button" className="btn btn-sm btn-general btn-light margin-left-5 userbuttons minibuttons " data-tip="Araç Sil" onClick={() => this.handleDeleteVehicle()}><i className="fas fa-times"></i> </button>
          </div>
          <div className="ml-auto p-2">
            <div className="d-flex">
               <label className="filterLabelYolcuIslemleri">Filtrele :</label><input id="editFilter" type="text" disabled={this.state.isFilterDisable} className="form-control edit editFilter margin-right-5" placeholder="Araç Plaka Filtrele" onChange={(event) => this.handleFilterSearch(event.target.value)}  />
            </div>              
          </div>
      </div>   
      </div>       
        <div className="SplitterPanelLeft">
        <ContextMenuTrigger id="submenu1" holdToDisplay={1000}>            
        {
          this.state.firstLoading ? <LoadingIndicator /> :
          this.props.buses.length > 0 ? (
            <BootstrapTable data={ this.props.buses } container className='bus-list arac-tanimlari-table' hover options={options}  selectRow={ selectRow } footerData={ footerData } footer pagination >
              <TableHeaderColumn dataField='BUSID' isKey={true} hidden>ID</TableHeaderColumn>
              <TableHeaderColumn dataField='BUSPLATE' width='auto' ref='busplateCol' className="displayCol" filter={ { type: 'TextFilter', delay: 1000}}  dataSort={ true } headerAlign='center'>Plaka No</TableHeaderColumn>
              <TableHeaderColumn dataField='BUSCAPACITY' width='180px' dataSort={ true } dataAlign='center' headerAlign='center' >Servis Kapasitesi</TableHeaderColumn>
              <TableHeaderColumn dataField='BUSLIMIT' width='180px' dataSort={ true } dataAlign='center'>Yolcu Limiti</TableHeaderColumn>
              <TableHeaderColumn dataField='ACTIVEFROM' width='200px' ref='activefromCol' className="displayCol" filter={ { type: 'TextFilter', delay: 1000, defaultValue:this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' : this.state.columnFilterData.ACTIVEFROM === undefined ? '' : this.state.columnFilterData.ACTIVEFROM.value } } dataSort={ true } headerAlign='center'>Başlangıç Zamanı</TableHeaderColumn>
              <TableHeaderColumn dataField='ACTIVETO' width='200px'  ref='activetoCol' className="displayCol" filter={ { type: 'TextFilter', delay: 1000, defaultValue:this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' : this.state.columnFilterData.ACTIVETO === undefined ? '' : this.state.columnFilterData.ACTIVETO.value } } dataSort={ true } headerAlign='center'>Bitiş Zamanı</TableHeaderColumn>
              <TableHeaderColumn dataField='BUSSTAT' width='100px' ref='busstatCol' className="displayCol" dataSort={ true } dataAlign='center' headerAlign='center' filterFormatted formatExtraData={ busStatTypes } filter={ { type: 'SelectFilter', options: busStatTypes, defaultValue: this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' : this.state.columnFilterData.BUSSTAT === undefined ? '' : this.state.columnFilterData.BUSSTAT.value } } dataFormat={(cell,row) => this.suColumnType(cell,row,'busstat') }>Durum</TableHeaderColumn>
              
          </BootstrapTable>          
          ) : 
          <p className="padding15">Gösterilecek kayıt yok.</p>
        }              
        </ContextMenuTrigger>        
                        
          {
            <table id="emp-arac-tanimlari" className="excel-table">  
            <tbody>             
              <tr>
                <td><b>Plaka No {this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' : this.state.columnFilterData.BUSPLATE !== undefined && '*'}</b></td>
                <td><b>Servis Kapasitesi</b></td>
                <td><b>Yolcu Limiti</b></td>
                <td><b>Başlangıç Tarihi{this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' :this.state.columnFilterData.ACTIVEFROM !== undefined && '*'}</b></td>
                <td><b>Bitiş Tarihi{this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' :this.state.columnFilterData.ACTIVETO !== undefined && '*'}</b></td>
                <td><b>Durum {this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' :this.state.columnFilterData.BUSTAT !== undefined && '*'}</b></td>
              </tr>                                   
                { 
                  this.props.excelData.map((p, index) => {  
                      return (
                      <tr key={index}>  
                        <td >{p.BUSPLATE}</td>  
                        <td >{p.BUSCAPACITY}</td>  
                        <td >{p.BUSLIMIT}</td>  
                        <td >{p.ACTIVEFROM}</td>  
                        <td >{p.ACTIVETO}</td>  
                        <td >{p.BUSSTAT === "0" ? "Aktif" : "Pasif" }</td>  
                      </tr>  
                      )
                  })  
                }  
                <tr>
                <td><b>Toplam</b></td>
                <td><b>{this.props.excelData.length}</b></td>
                <td><b></b></td>
                <td><b></b></td>
                <td><b></b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>  
              </tbody>  
              </table>  
              
          }          
                  


        </div>
          <PopupModal
              show={this.state.modalNewArac}
              onHide={() => this.setState({...this.state,modalNewArac:false})}
              titlemodal={`Yeni Araç Ekle`}
              onClick={()=> this.insertVehicle}
            >
            
            <p className="contentInfoText"><i className="fas fa-info-circle su-color"></i> Lütfen araç bilgilerini giriniz.</p>
            <form className="address-form" name="vehicle-form">
            <div className="form-row address-row">
              <div className="col-md-4 mb-3">
                <label htmlFor={`busplate_${this.guid}`}>Plaka No : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`busplate_${this.guid}`}  ref={(ref)=>{ this.busplate = ref;}} placeholder="Plaka No zorunlu"  required />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor={`buscapacity_${this.guid}`}>Servis Kapasitesi : <span className="requiredFieldMark">*</span></label>
                <input type="number" className="form-control" id={`buscapacity_${this.guid}`}  ref={(ref)=>{ this.buscapacity = ref;}} placeholder="Servis Kapasitesi zorunlu" defaultValue="0"  required  />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor={`buslimit_${this.guid}`}>Yolcu Limiti : <span className="requiredFieldMark">*</span></label>
                <input type="number" className="form-control" id={`buslimit_${this.guid}`}  ref={(ref)=>{ this.buslimit = ref;}} placeholder="Yolcu Limiti zorunlu" defaultValue="0"  required />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-4 mb-4">
                <label htmlFor={`activefrom_${this.guid}`}>Başlangıç Tarihi :</label>
                <div className="clearfix"></div>
                <DatePicker
                  selected={this.state.baslangicTarihi} 
                  onChange={this.handleBaslangicTarihi} 
                  className="form-control edit"
                  locale={tr}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Başlangıç tarihi seçiniz"
                />                 
              </div>
              <div className="col-md-4 mb-4">
                <label htmlFor={`activeto_${this.guid}`}>Bitiş Tarihi :</label>
                <div className="clearfix"></div>
                <DatePicker
                  selected={this.state.bitisTarihi} 
                  onChange={this.handleBitisTarihi} 
                  className="form-control edit"
                  locale={tr}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Bitiş tarihi seçiniz"
                />                
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-4 mb-4">
                <label htmlFor={`busstat_${this.guid}`}>Durum :</label>
                <Select id={`busstat_${this.guid}`} className="edit max-width-element" placeholder="Durum" options={durumOptions} value={this.state.statusOption} onChange={this.handleStatusChange} />
              </div>
            </div>                                     
            </form>                

            <LoadingLayer showLoading={this.props.showLoadingPopup} />
            <WarningLayerPopup hideWarning={hideWarningLayerPopup} text={this.props.warningMessage} warningType={this.props.warningMessageType} />
          </PopupModal> 
          
          <PopupModal
            show={this.state.modalEditArac}
            onHide={() => this.setState({...this.state,modalEditArac:false})}
            titlemodal={`Araç Düzelt - ${this.state.selectedBusData === null ? '' : this.state.selectedBusData.BUSPLATE }`}
            onClick={()=> this.updateVehicle}
            state={this.state}
          
          >
        
            <p className="contentInfoText"><i className="fas fa-info-circle su-color"></i> Lütfen araç bilgilerini giriniz.</p>
            <form className="address-form" name="vehicle-form">
            <div className="form-row address-row">
              <div className="col-md-4 mb-3">
                <label htmlFor={`busplate_${editGuid}`}>Plaka No : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`busplate_${editGuid}`}  ref={(ref)=>{ this.busplate = ref;}} placeholder="Plaka No zorunlu" defaultValue={this.state.selectedBusData === null ? "" : this.state.selectedBusData.BUSPLATE}  required />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor={`buscapacity_${editGuid}`}>Servis Kapasitesi : <span className="requiredFieldMark">*</span></label>
                <input type="number" className="form-control" id={`buscapacity_${editGuid}`}  ref={(ref)=>{ this.buscapacity = ref;}} placeholder="Servis Kapasitesi zorunlu" defaultValue={this.state.selectedBusData === null ? "" : this.state.selectedBusData.BUSCAPACITY}  required  />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor={`buslimit_${editGuid}`}>Yolcu Limiti : <span className="requiredFieldMark">*</span></label>
                <input type="number" className="form-control" id={`buslimit_${editGuid}`}  ref={(ref)=>{ this.buslimit = ref;}} placeholder="Yolcu Limiti zorunlu" defaultValue={this.state.selectedBusData === null ? "" : this.state.selectedBusData.BUSLIMIT}  required />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-4 mb-4">
                <label htmlFor={`activefrom_${editGuid}`}>Başlangıç Tarihi :</label>
                <div className="clearfix"></div>
                <DatePicker
                  selected={this.state.baslangicTarihi} 
                  onChange={this.handleBaslangicTarihi} 
                  className="form-control edit"
                  locale={tr}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Başlangıç tarihi seçiniz"
                />                 
              </div>
              <div className="col-md-4 mb-4">
                <label htmlFor={`activeto_${editGuid}`}>Bitiş Tarihi :</label>
                <div className="clearfix"></div>
                <DatePicker
                  selected={this.state.bitisTarihi} 
                  onChange={this.handleBitisTarihi} 
                  className="form-control edit"
                  locale={tr}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Bitiş tarihi seçiniz"
                />                
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-4 mb-4">
                <label htmlFor={`busstat_${editGuid}`}>Durum :</label>
                <Select id={`busstat_${editGuid}`} className="edit max-width-element" placeholder="Durum" options={durumOptions} value={this.state.statusOption} onChange={this.handleStatusChange} />
              </div>
            </div>                
            </form>                
            <LoadingLayer showLoading={this.props.showLoadingPopup} />
            <WarningLayerPopup hideWarning={hideWarningLayerPopup} text={this.props.warningMessage} warningType={this.props.warningMessageType} />
        </PopupModal>           
      
      

            <ReactTooltip /> 
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.User,
    isLoading: state.login.isLoading,
    error: state.login.error,
    buses: state.definitions.buses,
    excelData: state.definitions.excelData,
    showLoading:state.login.showLoading,
    showLoadingPopup:state.login.showLoadingPopup,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logOut: () => dispatch(actionCreators.userLogout()),
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setLoading: (showLoading) => dispatch({ type: LoginActionTypes.SET_LOADING, showLoading: showLoading}),
    setLoadingPopup: (showLoadingPopup) => dispatch({ type: LoginActionTypes.SET_LOADING_POPUP, showLoadingPopup: showLoadingPopup}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setBuses: (buses) => dispatch({ type: DefinitionsActionTypes.SET_BUSES, buses: buses}),
    setExcelData: (excelData) => dispatch({ type: DefinitionsActionTypes.SET_EXCEL_DATA, excelData: excelData})
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Buses));